import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { AvatarModule } from '../../../components/avatar/avatar.module';
import { AvatarSidebarCellModule } from '../../../components/avatar-sidebar-cell/avatar-sidebar-cell.module';
import { LogoModule } from '../../../components/logo/logo.module';
import { NextAppointmentCellModule } from '../../../components/next-appointment-cell/next-appointment-cell.module';
import { PersonalInformationRoundedCellModule } from '../../../components/personal-information-rounded-cell/personal-information-rounded-cell.module';
import { SidebarCellModule } from '../../../components/sidebar-cell/sidebar-cell.module';
import { WeightAndSizeModalModule } from '../../../components/weight-and-size-modal/weight-and-size-modal.module';
import { SidebarModule } from '../../../dashboard/components/sidebar/sidebar.module';
import { MySidebarComponent } from './my-sidebar.component';

@NgModule({
  declarations: [MySidebarComponent],
  imports: [
    CommonModule,
    LogoModule,
    SidebarModule,
    SidebarCellModule,
    NextAppointmentCellModule,
    PersonalInformationRoundedCellModule,
    WeightAndSizeModalModule,
    AvatarSidebarCellModule,
    AvatarModule,
    NgxBootstrapIconsModule,
    TooltipModule,
  ],
  exports: [MySidebarComponent],
})
export class MySidebarModule {}
